/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import type Mithril from 'mithril';
import type Bookshelf from '../../common/models/Bookshelf';
import type Status from '../../common/models/Status';

export interface BookshelfArticleStatusCountsAttrs extends ComponentAttrs {
	bookshelf: Bookshelf;
}

export default class BookshelfArticleStatusCounts<
	CustomAttrs extends BookshelfArticleStatusCountsAttrs = BookshelfArticleStatusCountsAttrs,
> extends Component<CustomAttrs> {
	protected statuses!: Status[];

	oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
		super.oninit(vnode);

		this.statuses = app.store.all<Status>('book_status');
	}

	view(): Mithril.Children {
		const { bookshelf } = this.attrs;

		return (
			<div className="BookshelfHero-infos">
				{this.statuses.map((status) => {
					const statusId = status.id();
					const count = statusId === undefined ? undefined : bookshelf.perStatusCount()[statusId];

					return (
						<span className="BookshelfArticleCount BookshelfArticleStatusCounts">
							<b>{count}</b> {status.name()}
						</span>
					);
				})}
			</div>
		);
	}
}
